import { ActionType } from "typesafe-actions";

import { Deeplink } from "../common_types";

import * as actions from "./actions";

export type BookingsAction = ActionType<typeof actions>;

export type BookingState = "cancelled" | "paid" | "processing";

export interface BookingItem {
  orderNumber: string;
  price: number;
  state: BookingsState;
  createdAt: string;
  origin: string;
  destination: string;
  host: string;
  deeplink: Deeplink;
  searchUserIp: string;
  marker: string;
  isRoundTrip: boolean;
}

export interface BookingsState {
  count: number;
  isLoading: boolean;
  items: BookingItem[];
}

export enum BookingsActionTypes {
  DATA_FETCH_REQUEST = "@Bookings/DATA_FETCH_REQUEST",
  DATA_FETCH_SUCCESS = "@Bookings/DATA_FETCH_SUCCESS",
  DATA_FETCH_ERROR = "@Bookings/DATA_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Bookings/GENERATE_REPORT_REQUEST",
}

export interface BookingsPayload {
  state?: BookingState[];
}
